module.exports = __webpack_public_path__ + "img/mty.4230ce97.png";